import { useSelector } from "react-redux"
import AuthComponent from "./pages/AuthComponent"
import StudentDashboard from "./pages/StudentDashboard"
import AdminDashboard from "./pages/AdminDashboard"
import FacultyDashboard from "./pages/FacultyDashboard"
import AccountDashboard from "./pages/AccounDashboard"
import PublicStudentRegistration from "./pages/PublicStudentRegistration"

function App() {
  const { user, loading, error } = useSelector((state) => state.auth)

  if (typeof window !== "undefined" && window.location?.pathname === "/public/register") {
    return <PublicStudentRegistration />
  }

  if (loading) {
    return (
      <div className="App">
        <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
      </div>
    )
  }

  const renderDashboard = () => {
    if (user?.role === "student") {
      return <StudentDashboard />
    } else if (user?.role === "admin" || user?.role === "super_admin") {
      return <AdminDashboard />
    } else if (user?.role === "account") {
      return <AccountDashboard />
    } else if (user?.role === "faculty" || user?.role === "hod") {
      return <FacultyDashboard />
    }
    return <AuthComponent />
  }

  return (
    <div className="App">
      {error && (
        <div style={{ padding: "10px", backgroundColor: "#ffebee", color: "#c62828", marginBottom: "10px" }}>
          Error: {error}
        </div>
      )}
      {!user ? <AuthComponent /> : renderDashboard()}
    </div>
  )
}

export default App
